import { render, staticRenderFns } from "./BaseIndivNewEdit.vue?vue&type=template&id=0831dc23&scoped=true&"
import script from "./BaseIndivNewEdit.vue?vue&type=script&lang=js&"
export * from "./BaseIndivNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0831dc23",
  null
  
)

export default component.exports